import { AfterViewInit, Component, ViewChild, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy, input, EventEmitter, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatService } from '../../services/chat.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { OpenApiService, Message, SummaryResponse, aiKeyStatusDTO, ApiKeys } from '../../../../core/services/open-api.service';
import { marked, Renderer } from 'marked';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-kotlin';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-csharp';
import { AuthService } from '../../../../core/services/auth.service';
import { DeepgramService } from '../../services/deepgram.service';
import { HeaderComponent } from "../../../../shared/components/layout/header/header.component";
import { ChatStreamRelayWebSocketService } from '../../../../core/services/chat-stream-relay-websocket.service';
import { API_URL, MAIN_PROD_WEBSOCKET_URL } from '../../../../config';
import { ScreenshotRelayWebSocketService } from '../../../../core/services/screenshot-relay-websocket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../../core/services/toast.service';
import { AES_SECRET_KEY } from '../../../../config';
import { importAesKey, decryptKey } from '../../../../core/utils/crypto-util';
import { LogChatHistoryDTO, LoginLogsService } from '../../../../shared/components/layout/dashboard/loginLogs/login-logs.service';
import { DiffService } from '../../services/diff.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CodingAiService } from '../../services/coding-ai.service';
import {
  CODING_CANCELLED_TEXT, CODING_FAILURE_MESSAGE, CodingAnswer, codingAnswerToMarkdown, encodeCodingAnswer, isCodingAnswer,
  isFailedCodingReply, latestCodingState, parseCodingAnswer
} from '../../services/coding-answer.model';
@Component({
  selector: 'app-chat-window',
  templateUrl: './chat-window.component.html',
  styleUrls: ['./chat-window.component.scss'],

})
export class ChatWindowComponent implements AfterViewInit, OnDestroy {
  /** Coding mode: answers in this conversation are produced and rendered as exact before/after code changes. */
  codingMode = false;
  /** True while a coding-mode answer is being prepared (lets Stop cancel it). */
  private codingPending = false;
  /** Cancels the coding request in flight when the helper presses stop or sends the next question. */
  private codingAbort: AbortController | null = null;
  private codingAi = inject(CodingAiService);
  messagesUpdated: boolean = false;

  upperText: string = '';
  showScratchpad: boolean = false;
  isStreaming = false;
  isNearBottom: boolean = true;
  userInput = '';
  recognition: any;
  isMicOn = false;
  isSummarizing = false;
  copiedMessage: string | null = null;
  copied = false;
  isLoadingMessages = true;
  isUploadingAttachment = false;
  attachedFileName: string = '';
  isUserScrolling = false;
  style: any;
  zoomLevel = 1;
  selectedPromptIdFromSidebar: any;
  selectedPromptId: any;
  sidebarOpened = false;
  s3FileUrl: string | { url: string } = '';
  s3FileType: 'image' | 'file' | '' = '';
  promptObj: any = null;
  interviewType: string = '';
  contextCache: any = null;
  systemPrompt: string = '';
  chatHistory: any[] = [];
  fileTypeError: string = '';
  loadedPromptData: any = null;
  loadedChatHistory: any[] = [];
  showZoomIndicator = false;
  openAiKey: string = '';
  claudeAiKey: string = '';
  // AI key status fetched on component load
  aiKeyStatuses: aiKeyStatusDTO[] = [];
  aiKeyOverallStatusText = '';
  
  // Track last bot response for diff comparison
  private lastBotResponse: string = '';
  enableDiffView: boolean = true; // Always enabled by default

  // Coach cue panel — always visible, horizontal scroll tiles
  clickedCueLabel: string | null = null;

  // Inline SVG markup for animated custom cues (img tags block SVG animations)
  static readonly COACH_CUE_SVGS: Record<string, string> = {
    'stop-sign': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><polygon points="50,4 82,18 96,50 82,82 50,96 18,82 4,50 18,18" fill="#dc2626" stroke="#991b1b" stroke-width="3"/><polygon points="50,12 76,24 88,50 76,76 50,88 24,76 12,50 24,24" fill="none" stroke="#fff" stroke-width="2.5"/><text x="50" y="56" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="24" font-weight="900" fill="#fff" letter-spacing="2">STOP</text></svg>`,
    'nod-more': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><style>@keyframes nod{0%,100%{transform:rotate(0)}25%{transform:rotate(-12deg)}50%{transform:rotate(8deg)}75%{transform:rotate(-6deg)}}.head-group{animation:nod 1.2s ease-in-out infinite;transform-origin:50px 65px}</style><g class="head-group"><circle cx="50" cy="40" r="28" fill="#fbbf24" stroke="#f59e0b" stroke-width="2"/><circle cx="39" cy="35" r="3.5" fill="#1e293b"/><circle cx="61" cy="35" r="3.5" fill="#1e293b"/><path d="M37,48 Q50,58 63,48" fill="none" stroke="#1e293b" stroke-width="2.5" stroke-linecap="round"/><path d="M50,5 L42,15 48,15 48,22 52,22 52,15 58,15Z" fill="#22c55e" opacity=".85"/><path d="M50,78 L42,68 48,68 48,61 52,61 52,68 58,68Z" fill="#22c55e" opacity=".85"/></g><rect x="44" y="68" width="12" height="10" rx="3" fill="#fbbf24" stroke="#f59e0b" stroke-width="1.5"/><rect x="35" y="78" width="30" height="14" rx="5" fill="#6366f1"/></svg>`,
    'sit-up': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><style>@keyframes straighten{0%,15%{transform:rotate(15deg)}40%,100%{transform:rotate(0)}}.body-group{animation:straighten 2s ease-out infinite;transform-origin:50px 85px}</style><rect x="30" y="60" width="40" height="5" rx="2" fill="#78716c"/><rect x="62" y="35" width="5" height="30" rx="2" fill="#78716c"/><rect x="62" y="32" width="10" height="5" rx="2" fill="#78716c"/><line x1="32" y1="65" x2="28" y2="90" stroke="#78716c" stroke-width="3" stroke-linecap="round"/><line x1="68" y1="65" x2="72" y2="90" stroke="#78716c" stroke-width="3" stroke-linecap="round"/><g class="body-group"><rect x="42" y="38" width="14" height="24" rx="5" fill="#6366f1"/><circle cx="49" cy="26" r="12" fill="#fbbf24" stroke="#f59e0b" stroke-width="1.5"/><circle cx="45" cy="24" r="2" fill="#1e293b"/><circle cx="53" cy="24" r="2" fill="#1e293b"/><path d="M44,30 Q49,34 54,30" fill="none" stroke="#1e293b" stroke-width="1.5" stroke-linecap="round"/><line x1="42" y1="44" x2="32" y2="56" stroke="#6366f1" stroke-width="4" stroke-linecap="round"/><line x1="56" y1="44" x2="66" y2="56" stroke="#6366f1" stroke-width="4" stroke-linecap="round"/><line x1="46" y1="62" x2="38" y2="82" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/><line x1="52" y1="62" x2="60" y2="82" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/></g><circle cx="82" cy="18" r="12" fill="#22c55e"/><path d="M76,18 L80,22 89,13" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    'enthuse': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><style>@keyframes bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}@keyframes starBurst{0%,100%{opacity:.3;transform:scale(.7)}50%{opacity:1;transform:scale(1.1)}}@keyframes waveLeft{0%,100%{transform:rotate(-20deg)}50%{transform:rotate(-60deg)}}@keyframes waveRight{0%,100%{transform:rotate(20deg)}50%{transform:rotate(60deg)}}.figure{animation:bounce .8s ease-in-out infinite}.star1{animation:starBurst 1s ease-in-out infinite}.star2{animation:starBurst 1s ease-in-out .3s infinite}.star3{animation:starBurst 1s ease-in-out .6s infinite}.star4{animation:starBurst 1s ease-in-out .15s infinite}.star5{animation:starBurst 1s ease-in-out .45s infinite}.arm-left{animation:waveLeft .6s ease-in-out infinite;transform-origin:42px 48px}.arm-right{animation:waveRight .6s ease-in-out infinite;transform-origin:58px 48px}</style><g class="figure"><circle cx="50" cy="30" r="14" fill="#fbbf24" stroke="#f59e0b" stroke-width="1.5"/><ellipse cx="50" cy="36" rx="6" ry="4" fill="#1e293b"/><circle cx="44" cy="28" r="2.5" fill="#1e293b"/><circle cx="56" cy="28" r="2.5" fill="#1e293b"/><line x1="41" y1="23" x2="47" y2="22" stroke="#1e293b" stroke-width="1.5" stroke-linecap="round"/><line x1="53" y1="22" x2="59" y2="23" stroke="#1e293b" stroke-width="1.5" stroke-linecap="round"/><rect x="43" y="44" width="14" height="22" rx="5" fill="#ef4444"/><g class="arm-left"><line x1="42" y1="48" x2="24" y2="32" stroke="#ef4444" stroke-width="4.5" stroke-linecap="round"/><circle cx="22" cy="30" r="4" fill="#fbbf24"/></g><g class="arm-right"><line x1="58" y1="48" x2="76" y2="32" stroke="#ef4444" stroke-width="4.5" stroke-linecap="round"/><circle cx="78" cy="30" r="4" fill="#fbbf24"/></g><line x1="47" y1="66" x2="40" y2="86" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/><line x1="53" y1="66" x2="60" y2="86" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/><ellipse cx="38" cy="88" rx="5" ry="3" fill="#1e293b"/><ellipse cx="62" cy="88" rx="5" ry="3" fill="#1e293b"/></g><polygon class="star1" points="15,15 17,20 22,20 18,24 19,29 15,26 11,29 12,24 8,20 13,20" fill="#fbbf24"/><polygon class="star2" points="85,12 87,17 92,17 88,21 89,26 85,23 81,26 82,21 78,17 83,17" fill="#fbbf24"/><polygon class="star3" points="12,55 14,59 18,59 15,62 16,66 12,64 8,66 9,62 6,59 10,59" fill="#f97316"/><polygon class="star4" points="88,50 90,54 94,54 91,57 92,61 88,59 84,61 85,57 82,54 86,54" fill="#f97316"/><polygon class="star5" points="50,4 52,8 56,8 53,11 54,15 50,13 46,15 47,11 44,8 48,8" fill="#fbbf24"/></svg>`
  };

  private svgHtmlCache = new Map<string, SafeHtml>();

  getSvgHtml(svgKey: string): SafeHtml | null {
    if (!svgKey) return null;
    if (this.svgHtmlCache.has(svgKey)) return this.svgHtmlCache.get(svgKey)!;
    const raw = ChatWindowComponent.COACH_CUE_SVGS[svgKey];
    if (!raw) return null;
    const safe = this.sanitizer.bypassSecurityTrustHtml(raw);
    this.svgHtmlCache.set(svgKey, safe);
    return safe;
  }

  coachCueCategories = [
    {
      name: 'Priority',
      color: '#f59e0b',
      cues: [
        { emoji: '🛑', label: 'Stop', fullLabel: 'Stop there', bg: '#2c1a1a', svgKey: 'stop-sign' },
        { emoji: '🔁', label: 'Repeat?', fullLabel: 'Can you repeat the question?', bg: '#1a2328' },
        { emoji: '😊', label: 'Smile', fullLabel: 'Smile more', bg: '#28251a' },
        { emoji: '🐢', label: 'Slow', fullLabel: 'Slow down', bg: '#1a2820' },
        { emoji: '🚀', label: 'Speed up', fullLabel: 'Speed up', bg: '#201a28' },
        { emoji: '🙂', label: 'Nod', fullLabel: 'Nod more', bg: '#28261a', svgKey: 'nod-more' },
        { emoji: '📢', label: 'Louder', fullLabel: 'Speak loudly', bg: '#28201a' },
        { emoji: '👁️', label: 'Pronounce', fullLabel: 'No pronunciation mistakes', bg: '#1a2028' },
        { emoji: '💻', label: 'Type act', fullLabel: 'Act like you are typing', bg: '#1a2226' },
      ]
    },
    {
      name: 'Posture',
      color: '#3b82f6',
      cues: [
        { emoji: '🪑', label: 'Sit up', fullLabel: 'Sit up straight', bg: '#24201a', svgKey: 'sit-up' },
        { emoji: '🔥', label: 'Enthuse!', fullLabel: 'Be enthusiastic!', bg: '#2c1c1c', svgKey: 'enthuse' },
      ]
    },
    {
      name: 'Say This Now',
      color: '#22c55e',
      cues: [
        { emoji: '✅', label: 'Yes', fullLabel: 'Yes', bg: '#1a2820' },
        { emoji: '❌', label: 'No', fullLabel: 'No', bg: '#2c1a1a' },
        { emoji: '🗣️', label: 'Explain', fullLabel: 'Try to explain', bg: '#1a2028' },
        { emoji: '😅', label: 'Misunderstood', fullLabel: 'Sorry, I think I misunderstood', bg: '#24241a' },
        { emoji: '🔍', label: 'Let me check', fullLabel: 'Yeah let me check', bg: '#20202a' },
        { emoji: '☀️', label: 'How\'s your day?', fullLabel: 'How was your day?', bg: '#28261a' },
        { emoji: '❓', label: 'Ask Q', fullLabel: 'Ask them a question back', bg: '#221a28' },
        { emoji: '🙏', label: 'Appreciate', fullLabel: 'Show appreciation', bg: '#26221a' },
        { emoji: '📅', label: '1 Week', fullLabel: '1 Week', bg: '#1a2226' },
        { emoji: '📅', label: '2 Weeks', fullLabel: '2 Weeks', bg: '#1a2624' },
        { emoji: '📋', label: 'Contract', fullLabel: 'Contract ending', bg: '#22221a' },
        { emoji: '💪', label: 'Got this!', fullLabel: 'You got this!', bg: '#221a24' },
      ]
    },
    {
      name: 'Wrap Up',
      color: '#eab308',
      cues: [
        { emoji: '🤝', label: 'Conclude', fullLabel: 'Conclude — Thank you for your time, hoping to hear back', bg: '#1a2422' },
      ]
    }
  ];

  // Memoization cache for formatMessage — keyed by "<msgId>|<text>" so Angular
  // does NOT recreate the SafeHtml (and destroy the DOM / copy buttons) on every
  // change-detection cycle while the text hasn't changed.
  private formatCache = new Map<string, SafeHtml>();

  @Input() zoomInClick = new EventEmitter<void>();
  @Input() zoomOutClick = new EventEmitter<void>();

  private abortController: AbortController | null = null;
  private _streamGeneration: number = 0; // tracks which stream is "current" to prevent stale finally blocks
  private transcriptBuffer = '';
  private conversationSubscription: Subscription;
  // AES helpers moved to crypto-util.ts

  @ViewChild('zoomContainer', { static: false })
  zoomContainer!: ElementRef;
  private routeSubscription: Subscription;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
   @ViewChild('input') private textareaInput!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('upperTextarea') private upperTextarea?: ElementRef<HTMLTextAreaElement>;

 loginLogsService: LoginLogsService;

  constructor(
    public chatService: ChatService,
    private openApiService: OpenApiService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private authService: AuthService,
    private deepgramService: DeepgramService,
    private chatStreamRelayWebSocketService: ChatStreamRelayWebSocketService,
    private screenshotRelayWsService: ScreenshotRelayWebSocketService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
    loginLogsService: LoginLogsService,
    private diffService: DiffService
  ) {
    // this.authService.setIsLoggedIn(true); // Set the user as logged in
    // this.initializeSpeechRecognition();
     this.loginLogsService = loginLogsService;
    this.conversationSubscription = this.chatService.currentConversation$.subscribe(() => {
      // Give Angular a tick to render, then run post-render fixes
      setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => this.addCopyButtonsToCodeBlocks(), 100);
      setTimeout(() => this.ensureImageThumbnails(), 120);
    });

    this.routeSubscription = this.route.queryParams.subscribe(params => {
      const newPromptId = params['templateId'] || '';
      if (newPromptId && newPromptId !== this.selectedPromptId) {
        this.selectedPromptId = newPromptId;
        this.loadChatHistory(this.selectedPromptId);
        this.connectScreenshotRelay(this.selectedPromptId);
      }
    });
  }


  ngAfterViewInit(): void {
    this.fetchAiApiKeys();
    this.initializeScrollListener();

    const templateId = this.getTemplateIdFromUrlOrInput();
    if (templateId) {
      this.loadChatHistory(templateId);
      // Load last bot response for this template from localStorage
      this.loadLastBotResponse(templateId);
    }

    this.scrollToBottom();
    this.addCopyButtonsToCodeBlocks();
    this.ensureImageThumbnails();
    // Defer AI key status fetch so it doesn't compete with sidebar/chat API calls for HTTP connections
    setTimeout(() => {
      try {
        this.fetchAiKeyStatus();
      } catch (err) {
        // Non-fatal
        console.warn('fetchAiKeyStatus call failed to start', err);
      }
    }, 3000);
  }

  /**
   * Ensure any <img> elements rendered into message bodies have the
   * expected thumbnail attributes and class. We avoid using bypassSecurityTrustHtml
   * and instead let Angular sanitize the HTML, then post-process the DOM to
   * add attributes (class, inline sizing, loading/decoding) so images preview
   * correctly while keeping content safe.
   */
  ensureImageThumbnails(): void {
    try {
      if (!this.scrollContainer || !this.scrollContainer.nativeElement) return;
      const imgs: NodeListOf<HTMLImageElement> = this.scrollContainer.nativeElement.querySelectorAll('.message-body img');
      imgs.forEach((img: HTMLImageElement) => {
        // Add class if missing
        if (!img.classList.contains('chat-thumbnail')) {
          this.renderer.addClass(img, 'chat-thumbnail');
        }
        // Attributes for performance and consistent sizing
        this.renderer.setAttribute(img, 'loading', 'lazy');
        this.renderer.setAttribute(img, 'decoding', 'async');
        this.renderer.setAttribute(img, 'draggable', 'false');
        // Inline style to prevent intrinsic-size expansion overriding CSS
        const style = 'width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;';
        this.renderer.setAttribute(img, 'style', style);
      });
    } catch (err) {
      // Non-fatal; logs for debugging
      console.warn('ensureImageThumbnails failed', err);
    }
  }

  ngOnDestroy() {
    this.conversationSubscription.unsubscribe();
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    this.chatStreamRelayWebSocketService.close();
    this.screenshotRelayWsService.close();
  }

  private connectScreenshotRelay(chatId: string) {
    if (!chatId) return;
    this.screenshotRelayWsService.connect(chatId, (data: string) => {
      try {
        const parsed = JSON.parse(data);
        if (parsed.type === 'screenshot' && parsed.s3Url) {
          this.s3FileUrl = parsed.s3Url;
          this.s3FileType = 'image';
          this.attachedFileName = parsed.fileName || 'screenshot.png';
          this.cdr.detectChanges();
        }
      } catch (e) {
        // Not JSON, ignore
      }
    });
  }

  sendCoachCue(cue: { emoji: string; label: string; fullLabel?: string; svgKey?: string }): void {
    if (!this.screenshotRelayWsService.isConnected()) {
      this.toastService.show('Not connected to relay. Select an interview first.', 'warning');
      return;
    }
    // Visual feedback - track clicked emoji
    this.clickedCueLabel = cue.label;
    setTimeout(() => {
      this.clickedCueLabel = null;
    }, 500);
    const sendLabel = cue.fullLabel || cue.label;
    const payload: any = { type: 'coach-cue', emoji: cue.emoji, label: sendLabel };
    if (cue.svgKey) payload.svgKey = cue.svgKey;
    this.screenshotRelayWsService.send(JSON.stringify(payload));
  }

  // Fetch AI key status from backend and cache locally. First refresh stale inactive records (>=15 minutes).
  async fetchAiKeyStatus(): Promise<void> {
    try {
      const res = await this.openApiService.refreshAndGetAiKeyStatus(480);
      this.aiKeyStatuses = res || [];
      this.aiKeyOverallStatusText = this.getAiKeyOverallStatusText();
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Failed to fetch AI key status', err);
    }
  }

  isAiKeyHealthy(): boolean {
    if (!this.aiKeyStatuses || this.aiKeyStatuses.length === 0) return true;
    // treat any non-OK or any error text as unhealthy
    return !this.aiKeyStatuses.some(s => (s.status && String(s.status).toLowerCase() !== 'ok') || (s.error && String(s.error).trim() !== ''));
  }

  getAiKeyOverallStatusText(): string {
    if (!this.aiKeyStatuses || this.aiKeyStatuses.length === 0) return 'AI keys: unknown';
    if (this.isAiKeyHealthy()) return 'AI keys: OK';
    const issues = this.aiKeyStatuses.filter(s => (s.status && String(s.status).toLowerCase() !== 'ok') || (s.error && String(s.error).trim() !== '')).length;
    return `AI key issues: ${issues}`;
  }

  onPromptSelected(promptId: any): void {
    this.selectedPromptId = promptId;
    console.log('Prompt ID in parent:', this.selectedPromptId);
    if (this.selectedPromptId) {
      this.loadChatHistory(this.selectedPromptId);
      this.connectScreenshotRelay(this.selectedPromptId);
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { templateId: this.selectedPromptId },
      queryParamsHandling: 'merge', // merge to keep other params
    });
  }
  private initializeScrollListener(): void {
    this.chatService.selectConversation({
      id: '',
      title: '',
      messages: [],
      chatThreadId: '',
    });
    this.scrollContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
  }

  private getTemplateIdFromUrlOrInput(): string {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      return params.get('templateId') || this.selectedPromptId || '';
    }
    return this.selectedPromptId || '';
  }


  private async loadChatHistory(templateId: string): Promise<void> {
    this.isLoadingMessages = true;
    // Clear cached formatted messages when switching templates
    this.formatCache.clear();
    this.codingMode = this.readCodingMode(templateId);
    try {
      // Load prompt data and chat history in parallel
      const [promptData, history] = await Promise.all([
        this.openApiService.getPromptById(templateId).toPromise(),
        this.openApiService.getChatHistoryByPromptId(templateId).toPromise()
      ]);

      // Store the loaded data
      this.loadedPromptData = promptData;
      this.loadedChatHistory = history || [];

      // Initialize ISE state for this prompt (restores from localStorage if available)
      this.openApiService.setPromptId(templateId);

      if (history && history.length > 0) {
        const reversedHistory = [...history].reverse();
        const messages = reversedHistory.flatMap((h) => {
          const msgs: Message[] = [
            { text: h.question, sender: 'user', timestamp: new Date(h.timestamp) },
          ];
          if (h.answer) {
            msgs.push({ text: h.answer, sender: 'bot', timestamp: new Date(h.timestamp) });
          }
          if (h.s3Url && h.s3Url.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i)) {
            msgs[0].text = `${h.question}<br><a href='${h.s3Url}' target='_blank' rel='noopener noreferrer'><img class='chat-thumbnail' src='${h.s3Url}' alt='attachment' loading='lazy' decoding='async' draggable='false' style="width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;"/></a>`;
          }
          return msgs;
        });

        // Annotate history bot messages with diff context so refresh shows red/green.
        // Walk the flat message list; whenever we see a bot message that contains code
        // AND the previous bot message also had code, mark it with showDiff + previousText.
        let prevBotText: string | undefined;
        for (const msg of messages) {
          if (msg.sender === 'bot') {
            if (prevBotText && this.hasCodeBlock(prevBotText) && this.hasCodeBlock(msg.text)) {
              msg.showDiff = true;
              msg.previousText = prevBotText;
            }
            prevBotText = msg.text;
          }
        }

        const conversation = {
          id: reversedHistory[0].chatThreadId || templateId,
          title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
          messages: messages,
          chatThreadId: reversedHistory[0].chatThreadId || templateId,
        };

        this.chatService.selectConversation(conversation);

        // Seed lastBotResponse from the most recent bot answer in history
        // so diff detection works immediately on the very first modification request.
        // history[0] is the most recent entry (backend returns newest-first).
        const lastEntry = history[0];
        if (lastEntry?.answer && this.hasCodeBlock(lastEntry.answer)) {
          this.lastBotResponse = lastEntry.answer;
          this.saveLastBotResponse(templateId, lastEntry.answer);
        }
      }
    } catch (error) {
      console.error('Error loading chat history:', error);
      this.toastService.show('Unable to load chat history. Please refresh the page.', 'error');
    } finally {
      this.isLoadingMessages = false;
      this.scrollToBottom();
    }
  }

  get currentConversation$() {
    return this.chatService.currentConversation$;
  }

  sendMessageOnEnter(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      const trimmedInput = this.userInput.trim();
      if (trimmedInput) {
        this.sendMessage();
      }
    }
  }

  toggleSidebar() {
    this.sidebarOpened = !this.sidebarOpened;
  }
  onScroll(): void {
    const el = this.scrollContainer.nativeElement;
    this.isUserScrolling = el.scrollTop + el.clientHeight < el.scrollHeight;
    this.isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50; // or your threshold
  }

 async sendMessage() {
  if (this.codingMode) {
    await this.sendCodingMessage();
    return;
  }
  // If already streaming, abort the current answer and start the new one
  if (this.isStreaming) {
    this.abortCurrentStreamAndSavePartial();
    await new Promise(res => setTimeout(res, 50));
  }

  // Increment generation so the OLD stream's finally block becomes a no-op
  const myGeneration = ++this._streamGeneration;

  // Set streaming immediately to change icon and prevent duplicate sends
  this.isStreaming = true;

  this.currentConversation$.pipe(take(1)).subscribe(async currentConv => {
    const combinedText = (this.upperText + ' ' + this.userInput).trim();
    if (!combinedText || !currentConv) {
      if (this._streamGeneration === myGeneration) this.isStreaming = false;
      return;
    }

    if (this.s3FileUrl) {
      this.sendMessageWithAttachment(currentConv);
      return;
    }

    const promptId = this.selectedPromptId || '';
    if (!promptId || !this.loadedPromptData) {
      if (this._streamGeneration === myGeneration) this.isStreaming = false;
      this.toastService.show('Error: Template not loaded properly', 'error');
      return;
    }

    // Use the preloaded prompt data
    const interviewType = this.loadedPromptData.interviewType || '';

    let provider: 'openai' | 'anthropic' | 'vertex-ai-claude' = 'openai';
    let model = 'gpt-4o';
    let vertexModelKey = '';

    if (interviewType === 'practice') {
      model = 'gpt-4.1-mini';
    } else if (interviewType === 'screening') {
      model = 'gpt-5.2';
    } else if (interviewType === 'firstround') {
      model = 'gpt-5.2';
    } else if (interviewType === 'finalround') {
      provider = 'vertex-ai-claude';
      vertexModelKey = 'anthropic-claude-sonnet-4-6';
    }

    const userMessageText = combinedText;
    this.userInput = '';
    this.upperText = '';
    this.transcriptBuffer = '';
    // The scratchpad just emptied into the outgoing message, so close it.
    // Its visibility is a separate flag from its content (unlike the overlay
    // chat window, which binds *ngIf straight to upperText), so clearing the
    // text alone would leave an empty panel sitting open.
    this.showScratchpad = false;

    // Check if we should show diff for this response
    const showDiff = this.shouldShowDiffForUserMessage(userMessageText);

    if (currentConv.messages.length === 0) {
      this.chatService.updateConversationTitle(userMessageText.substring(0, 25) + '...');
    }

    const userMsg: Message = {
      id: `user-${Date.now()}`,
      text: userMessageText,
      sender: 'user',
      timestamp: new Date()
    };
    this.chatService.addMessage(userMsg);

    // Show an immediate initial response
    const initialResponse = "";
    const botMsgId = `bot-${Date.now()}`;
    const botPlaceholderMsg: Message = {
      id: botMsgId,
      text: initialResponse,
      sender: 'bot',
      timestamp: new Date(),
      showDiff: showDiff,
      previousText: showDiff ? this.lastBotResponse : undefined
    };

    console.log('Creating bot message ID:', botMsgId, 'with showDiff:', showDiff, 'previousText:', !!botPlaceholderMsg.previousText);
    this.chatService.addMessage(botPlaceholderMsg);

    // Scroll immediately after adding messages
    setTimeout(() => this.scrollToBottom(), 0);

    // Get accurate bot placeholder index and current UI messages (already in memory)
    const messages = (await this.chatService.currentConversation$.pipe(take(1)).toPromise())?.messages || [];
    const botMessageIndex = messages.length - 1;

    // Build context from in-memory UI messages (eliminates extra /chathistory HTTP call on each send)
    // Exclude the last 2 entries: the user message + empty bot placeholder just added
    const historyMessages = messages.slice(0, -2);
    const context = this.openApiService.buildContextFromUiMessages(
      this.loadedPromptData,
      userMessageText,
      historyMessages
        .filter(m => !(m.sender === 'bot' && isFailedCodingReply(m.text)))
        .map(m => this.asContextMessage(m)),
      'ise'
    );

    const chatId = promptId;
    // If India Production, always use main prod websocket URL for chat window
    const isIndiaProd = API_URL.toLowerCase().includes('chat-ind-prod');
    const wsUrl = isIndiaProd ? MAIN_PROD_WEBSOCKET_URL : undefined;

    if (this.chatStreamRelayWebSocketService.isConnected()) {
      // WebSocket already open — send new-answer signal IMMEDIATELY (guaranteed delivery)
      this.chatStreamRelayWebSocketService.send('__NEW_ANSWER__');
    } else {
      // First connection — connect now (no signal needed, there's no previous answer)
      this.chatStreamRelayWebSocketService.connect(chatId, () => {}, undefined, wsUrl);
    }

    // Set up streaming with immediate feedback
    this.abortController = new AbortController();
    let fullAnswer = '';

    // Start showing thinking indicators immediately
    let thinkingDots = '';
    const thinkingInterval = setInterval(() => {
      // Stop thinking dots if this stream is no longer current
      if (this._streamGeneration !== myGeneration || !this.isStreaming || fullAnswer) {
        clearInterval(thinkingInterval);
      } else {
        thinkingDots = thinkingDots.length >= 3 ? '' : thinkingDots + '.';
        this.chatService.updateBotMessage(botMessageIndex, '' + '');
      }
    }, 300);

    let firstChunk = true;
    try {
      console.log('Selected provider:', provider, '| model:', model || vertexModelKey);
      if (provider === 'vertex-ai-claude') {
        this.openApiService.warmGcpToken();
        await this.openApiService.streamVertexAIClaudeAnswerWithContext(
          context,
          botMessageIndex,
          {
            updateBotMessage: (idx: number, text: string) => {
              if (this._streamGeneration !== myGeneration) return;
              if (firstChunk && text.length > 0) {
                firstChunk = false;
                text = text.replace(/^\.{3}/, '');
              }
              this.chatService.updateBotMessage(idx, text);
              this.chatStreamRelayWebSocketService.send(text);
              setTimeout(() => this.scrollToBottomWithPadding(10), 10);
            },
            finalizeConversation: () => {
              if (this._streamGeneration === myGeneration) {
                this.chatService.finalizeConversation();
              }
            }
          },
          (partial: string) => {
            if (this._streamGeneration === myGeneration) fullAnswer = partial;
          },
          this.abortController.signal,
          vertexModelKey,
          interviewType,
          undefined,
          this.selectedPromptId || ''
        );
      } else {
        await this.openApiService.streamAskQuestionWithContext(
        context,
        botMessageIndex,
        {
          updateBotMessage: (idx: number, text: string) => {
            // Guard: only update if this is still the current stream
            if (this._streamGeneration !== myGeneration) return;
            if (firstChunk && text.length > 0) {
              firstChunk = false;
              text = text.replace(/^\.{3}/, '');
            }
            this.chatService.updateBotMessage(idx, text);
            this.chatStreamRelayWebSocketService.send(text);
            setTimeout(() => this.scrollToBottomWithPadding(10), 10);
          },
          finalizeConversation: () => {
            if (this._streamGeneration === myGeneration) {
              this.chatService.finalizeConversation();
            }
          }
        },
        (partial: string) => {
          if (this._streamGeneration === myGeneration) fullAnswer = partial;
        },
        this.abortController.signal,
        model,
        interviewType,
        true,  // skipStatusCheck: always attempt the real API call
        this.selectedPromptId || ''
      );
      }
    } catch (e) {
      if (this._streamGeneration === myGeneration) {
        this.chatService.finalizeConversation();
      }
    } finally {
      // Only do cleanup if this is still the current stream.
      // If a newer stream started, it owns isStreaming/abortController/websocket now.
      if (this._streamGeneration === myGeneration) {
        if (fullAnswer) {
          // Fix 2: Only update lastBotResponse when the answer contains code.
          // If the bot replied with text-only (e.g. "time complexity is O(n)"),
          // keep the previous code baseline intact so the next code question
          // still diffs against the last real code response.
          if (this.hasCodeBlock(fullAnswer)) {
            this.lastBotResponse = fullAnswer;
            this.saveLastBotResponse(promptId, fullAnswer);
          }
        }

        this.isStreaming = false;
        this.abortController = null;
        // Don't close WebSocket — keep it alive for rapid follow-up questions

        // Background ISE extraction (fire-and-forget)
        if (fullAnswer) {
          const currentMsgs = (await this.chatService.currentConversation$.pipe(take(1)).toPromise())?.messages || [];
          this.extractConversationState(currentMsgs);
        }
      }
    }

    // Save answer and append log chat history asynchronously
    if (fullAnswer) {
      this.openApiService.saveAnswer(promptId, userMessageText, fullAnswer)
        .then((response: any) => {
          const chatHistoryId = response?.id || '';
          this.appendLogChatHistoryAsync(promptId, chatHistoryId, userMessageText);
        })
        .catch((err: any) => {
          console.error('Failed to save answer:', err);
        });
    }
  });

  this.isNearBottom = true;
  this.isUserScrolling = false;
  this.messagesUpdated = true;
}

/**
 * Appends chat history log asynchronously without blocking
 */
private appendLogChatHistoryAsync(promptId: string, chatHistoryId: string, name: string): void {
  const loginLogId = sessionStorage.getItem('loginLogId');
  
  if (!loginLogId || loginLogId.trim().length === 0) {
    console.warn('No loginLogId found in session, skipping log chat history');
    return;
  }

  const logChatHistory: LogChatHistoryDTO = {
    id: this.loginLogsService.generateUUID(),
    promptId: promptId,
    chathistoryId: chatHistoryId,
    timestamp: Date.now()
  };

  this.loginLogsService.appendLogChatHistory(loginLogId, logChatHistory).subscribe({
    next: (response: any) => {
      console.log('Log chat history appended successfully:', response);
    },
    error: (err: any) => {
      console.error('Failed to append log chat history:', err);
    }
  });
}




  scrollToStopAtLastQuestion() {
    const container = this.scrollContainer.nativeElement;
    // Get all message wrapper elements
    const messageElements = container.querySelectorAll('.message-wrapper');
    if (messageElements.length === 0) {
      // fallback to scroll bottom if no messages
      container.scrollTop = container.scrollHeight;
      return;
    }

    // Find the last user message (assuming sender 'user')
    let lastUserMsg: HTMLElement | null = null;
    for (let i = messageElements.length - 1; i >= 0; i--) {
      const msgElem = messageElements[i] as HTMLElement;
      // You need to identify user messages, e.g., with a class 'user'
      if (msgElem.classList.contains('user')) {
        lastUserMsg = msgElem;
        break;
      }
    }

    if (!lastUserMsg) {
      // If no user message found, scroll to bottom
      container.scrollTop = container.scrollHeight;
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const lastUserMsgRect = lastUserMsg.getBoundingClientRect();

    // Calculate where to scroll so the last user message bottom is just above the viewport
    const targetScrollTop = container.scrollTop + (lastUserMsgRect.bottom - containerRect.top) - 10; // 10px margin

    // Scroll to that position
    container.scrollTop = targetScrollTop;
  }



  ngAfterViewChecked() {
    if (this.messagesUpdated) {
      this.scrollToBottom(true);
      // this.scrollToBottomWithPadding()
      this.messagesUpdated = false;
    }
  }

  // trackBy function for *ngFor to preserve DOM nodes when messages update
  trackByMessage(index: number, msg: any): any {
    if (!msg) return index;
    if (msg.id !== undefined && msg.id !== null) return msg.id;
    if (msg.timestamp) return typeof msg.timestamp === 'number' ? msg.timestamp : new Date(msg.timestamp).getTime();
    return index;
  }

  scrollToBottomWithPadding(padding = 10) {
    const container = this.scrollContainer.nativeElement;
    if (!this.isUserScrolling) { // respects manual user scroll
      container.scrollTop = container.scrollHeight - container.clientHeight - padding;
    }
  }



  moveInputToUpper() {
    if (this.userInput.trim()) {
      this.upperText = this.upperText ? (this.upperText + ' ' + this.userInput.trim()) : this.userInput.trim();
    }
    this.showScratchpad = true;
    this.userInput = '';
    this.transcriptBuffer = '';
    this.scrollScratchpadToLatest();
  }

  /** Scroll the scratchpad to its newest line.
   *  The textarea keeps its scroll pinned at the top when text is appended, so
   *  whatever was just moved up lands out of sight below the fold. Runs on the
   *  next macrotask, after ngModel has written the new value into the DOM. */
  private scrollScratchpadToLatest(): void {
    setTimeout(() => {
      const el = this.upperTextarea?.nativeElement;
      if (!el) return;
      // Caret first: moving it after scrolling would undo the scroll.
      try { el.setSelectionRange(el.value.length, el.value.length); } catch { }
      el.scrollTop = el.scrollHeight;
    });
  }

  /** Abort the current stream, save partial response, and clean up */
  private abortCurrentStreamAndSavePartial(): void {
    if (!this.abortController) return;

    this.abortController.abort();
    this.isStreaming = false;

    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv?.messages?.length) return;

      const messages = currentConv.messages;
      const lastMsg = messages[messages.length - 1];
      if (lastMsg?.sender === 'bot' && lastMsg.text) {
        // Save partial answer to backend (fire-and-forget)
        const promptId = this.selectedPromptId || '';
        const userMsg = messages[messages.length - 2];
        if (promptId && userMsg?.sender === 'user') {
          this.openApiService.saveAnswer(promptId, userMsg.text, lastMsg.text)
            .catch(err => console.warn('Failed to save partial answer:', err));
        }
      }

      this.chatService.finalizeConversation();
      // Don't close WebSocket here — keep it alive for the next stream's __NEW_ANSWER__ signal
    });

    this.abortController = null;
  }

  stopStreaming() {
    if (this.codingPending) {
      this.cancelCodingAnswer();
      return;
    }
    if (this.isStreaming && this.abortController) {
      this.abortCurrentStreamAndSavePartial();
    }
  }

  // ---------------------------------------------------------------------------
  // Coding mode: same conversation, different answer style.
  // ---------------------------------------------------------------------------

  /** Remembered per interview so a page refresh keeps the mode. */
  toggleCodingMode(): void {
    if (this.isStreaming || !this.selectedPromptId) return;
    this.codingMode = !this.codingMode;
    try {
      localStorage.setItem(`codingMode_${this.selectedPromptId}`, this.codingMode ? '1' : '0');
    } catch { /* storage unavailable: the toggle still works for this page */ }
  }

  isCodingAnswer(text: string): boolean {
    return isCodingAnswer(text);
  }

  private readCodingMode(promptId: string): boolean {
    try {
      return localStorage.getItem(`codingMode_${promptId}`) === '1';
    } catch {
      return false;
    }
  }

  /** Code-block detection for the legacy diff view; coding-mode envelopes are not ordinary code answers. */
  private hasCodeBlock(text: string | undefined): boolean {
    return !!text && text.includes('```') && !isCodingAnswer(text);
  }

  private plainTextOf(msg: Message): string {
    const answer = parseCodingAnswer(msg.text);
    return answer ? codingAnswerToMarkdown(answer) : msg.text;
  }

  /** Coding answers go to the model as readable markdown, not as the JSON envelope. */
  private asContextMessage(msg: Message): Message {
    const answer = parseCodingAnswer(msg.text);
    return answer ? { ...msg, text: codingAnswerToMarkdown(answer) } : msg;
  }

  /**
   * Background ISE state extraction (topic, artifacts, pending work) after any answer, normal or coding,
   * so switching coding mode on or off never loses context. Coding answers are fed as readable markdown.
   */
  private extractConversationState(messages: Message[]): void {
    const recentHistory = messages.reduce((acc: any[], msg: Message, idx: number, arr: Message[]) => {
      const next = arr[idx + 1];
      if (msg.sender === 'user' && next?.sender === 'bot' && next.text && !isFailedCodingReply(next.text)) {
        acc.push({ question: this.plainTextOf(msg), answer: this.plainTextOf(next), timestamp: msg.timestamp });
      }
      return acc;
    }, []);
    this.openApiService.preExtractState(recentHistory).catch(err =>
      console.warn('[ISE] Background extraction failed:', err)
    );
  }

  private scrollToMessageTop(index: number): void {
    try {
      const container = this.scrollContainer?.nativeElement as HTMLElement | undefined;
      const target = container?.querySelectorAll('.message-wrapper')[index] as HTMLElement | undefined;
      if (!container || !target) return;
      container.scrollTop = Math.max(0, target.offsetTop - container.offsetTop - 12);
    } catch (error) {
      console.warn('[CodingMode] Could not scroll to the answer', error);
    }
  }

  private cancelCodingAnswer(): void {
    this._streamGeneration++;
    this.codingPending = false;
    this.isStreaming = false;
    this.codingAbort?.abort();
    this.codingAbort = null;
    this.currentConversation$.pipe(take(1)).subscribe(conv => {
      const index = (conv?.messages.length || 0) - 1;
      const last = index >= 0 ? conv?.messages[index] : undefined;
      if (last?.sender === 'bot' && (!last.text || parseCodingAnswer(last.text)?.streaming)) {
        this.chatService.updateBotMessage(index, CODING_CANCELLED_TEXT);
        this.chatService.finalizeConversation();
      }
    });
  }

  /**
   * Sends the helper's text and/or screenshot through coding mode. The previous coding answer in this
   * conversation is the baseline, so follow-ups stay surgical; the reply is stored as an ordinary
   * assistant message (a tagged envelope) and relayed to the learner page like any other answer.
   */
  private async sendCodingMessage(): Promise<void> {
    if (this.isUploadingAttachment) return;
    if (this.s3FileType === 'file') {
      this.toastService.show('In coding mode, attach a screenshot or paste the code instead of a document.', 'warning');
      return;
    }
    const promptId = this.selectedPromptId || '';
    const text = (this.upperText + ' ' + this.userInput).trim();
    const attachment = this.s3FileUrl;
    const imageUrl = typeof attachment === 'string' ? attachment : (attachment?.url || '');
    if (!text && !imageUrl) return;
    if (!promptId || !this.loadedPromptData) {
      this.toastService.show('Error: Template not loaded properly', 'error');
      return;
    }
    const currentConv = await firstValueFrom(this.currentConversation$.pipe(take(1)));
    if (!currentConv) return;

    if (this.codingPending) this.cancelCodingAnswer();
    else if (this.isStreaming) {
      this.abortCurrentStreamAndSavePartial();
      await new Promise(res => setTimeout(res, 50));
    }
    const myGeneration = ++this._streamGeneration;
    this.isStreaming = true;
    this.codingPending = true;

    this.userInput = '';
    this.upperText = '';
    this.transcriptBuffer = '';
    this.showScratchpad = false;
    this.s3FileUrl = '';
    this.s3FileType = '';
    this.attachedFileName = '';
    if (this.fileInput) this.fileInput.nativeElement.value = '';

    if (currentConv.messages.length === 0) {
      this.chatService.updateConversationTitle((text || 'Coding question').substring(0, 25) + '...');
    }
    let userMsgText = text;
    if (imageUrl) {
      userMsgText += `<br><a href='${imageUrl}' target='_blank' rel='noopener noreferrer'><img class='chat-thumbnail' src='${imageUrl}' alt='attachment' loading='lazy' decoding='async' draggable='false' style="width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;"/></a>`;
    }
    this.chatService.addMessage({ id: `user-${Date.now()}`, text: userMsgText, sender: 'user', timestamp: new Date() });
    // Empty, like the normal chat: the answer starts printing in place as soon as the first words arrive.
    this.chatService.addMessage({ id: `bot-${Date.now()}`, text: '', sender: 'bot', timestamp: new Date() });
    setTimeout(() => this.scrollToBottom(), 0);

    const messages = (await firstValueFrom(this.chatService.currentConversation$.pipe(take(1))))?.messages || [];
    const botMessageIndex = messages.length - 1;
    const state = latestCodingState(messages.slice(0, -2));

    const isIndiaProd = API_URL.toLowerCase().includes('chat-ind-prod');
    const wsUrl = isIndiaProd ? MAIN_PROD_WEBSOCKET_URL : undefined;
    let relayStarted = false;
    if (this.chatStreamRelayWebSocketService.isConnected()) {
      this.chatStreamRelayWebSocketService.send('__NEW_ANSWER__');
      relayStarted = true;
    } else {
      this.chatStreamRelayWebSocketService.connect(promptId, () => {}, undefined, wsUrl);
    }

    // Streaming: show the answer as it is written, and mirror it to the learner page (kept small enough for the relay).
    let lastRelay = 0;
    let firstPartial = true;
    const onPartial = (partial: CodingAnswer) => {
      if (this._streamGeneration !== myGeneration) return;
      const partialText = encodeCodingAnswer(partial);
      this.chatService.updateBotMessage(botMessageIndex, partialText);
      firstPartial = false;
      // Follow the answer as it is typed, like the normal chat (stops following when the helper scrolls up).
      setTimeout(() => this.scrollToBottomWithPadding(10), 10);
      const now = Date.now();
      if (now - lastRelay < 80 || !this.chatStreamRelayWebSocketService.isConnected()) return;
      if (new TextEncoder().encode(partialText).length > 24000) return;
      lastRelay = now;
      if (!relayStarted) {
        this.chatStreamRelayWebSocketService.send('__NEW_ANSWER__');
        relayStarted = true;
      }
      this.chatStreamRelayWebSocketService.send(partialText);
    };
    this.codingAbort = new AbortController();

    const instruction = text || (state.files.length
      ? 'Apply what this screenshot asks for to the current code, or fix the mistakes it shows.'
      : 'Solve the problem shown in this screenshot. If it shows code with mistakes, read it exactly and fix it.');
    let answerText = '';
    let answer: CodingAnswer | null = null;
    try {
      const reply = await this.codingAi.propose(state, instruction, imageUrl, {
        mainPrompt: this.loadedPromptData?.prompt || '',
        role: this.loadedPromptData?.interviewingRole || this.loadedPromptData?.presentRole || '',
        jobDescription: this.loadedPromptData?.jobDescription || ''
      }, messages.slice(0, -2), onPartial, this.codingAbort.signal);
      if (this._streamGeneration !== myGeneration) return;
      // A new, separate question is shown fresh (no "before" code); only a change to the current code is a diff.
      answer = {
        v: 1,
        language: reply.language,
        problem: reply.problem || state.problem,
        summary: reply.summary,
        clarification: reply.clarification,
        baseline: reply.clarification ? [] : (reply.baseline ?? (reply.newProblem ? [] : state.files)),
        files: reply.clarification ? [] : reply.files,
        notes: reply.notes,
        transcribed: !reply.clarification && reply.baseline !== null
      };
      answerText = encodeCodingAnswer(answer);
    } catch (error) {
      if (this._streamGeneration !== myGeneration) return;
      // Technical details go to the console only; the helper and the learner see a plain message.
      console.error('[CodingMode] Failed to prepare the answer', error);
      answerText = CODING_FAILURE_MESSAGE;
    }

    this.chatService.updateBotMessage(botMessageIndex, answerText);
    this.chatService.finalizeConversation();
    this.codingPending = false;
    this.isStreaming = false;
    this.codingAbort = null;
    if (firstPartial) setTimeout(() => this.scrollToMessageTop(botMessageIndex), 60);

    if (!answer) {
      if (relayStarted) this.chatStreamRelayWebSocketService.send(answerText);
      return;
    }

    // Keep the shared conversation state in sync so a later normal-chat question knows about this code.
    this.currentConversation$.pipe(take(1)).subscribe(conv => { if (conv) this.extractConversationState(conv.messages); });

    // Persist first, then relay: a very large answer is fetched by the learner page from history instead.
    let saved = false;
    try {
      const response: any = await this.openApiService.saveAnswer(promptId, text || 'Screenshot', answerText, imageUrl || undefined);
      this.appendLogChatHistoryAsync(promptId, response?.id || '', text || 'Screenshot');
      saved = true;
    } catch (error) {
      console.error('Failed to save coding answer:', error);
    }
    if (!relayStarted) this.chatStreamRelayWebSocketService.send('__NEW_ANSWER__');
    const bytes = new TextEncoder().encode(answerText).length;
    if (bytes <= 24000 || !saved) {
      this.chatStreamRelayWebSocketService.send(answerText);
    } else {
      this.chatStreamRelayWebSocketService.send('__CODING_ANSWER_SAVED__');
    }
  }
  onZoomIn() {
    let newPercentage = this.zoomLevel * 100 + 10;
    this.setZoomPercentage(newPercentage);
  }

  onZoomOut() {
    let newPercentage = this.zoomLevel * 100 - 10;
    this.setZoomPercentage(newPercentage);
  }

  onRefreshChat() {
    const templateId = this.selectedPromptId || this.getTemplateIdFromUrlOrInput();
    if (templateId) {
      this.loadChatHistory(templateId);
    }
  }

  get zoomDisplayValue(): string {
    return Math.round(this.zoomLevel * 100) + '%';
  }

  setZoom(change: number) {
    this.zoomLevel = Math.min(Math.max(this.zoomLevel + change, 0.5), 2);
    this.applyZoomToContainer();

  }

  setZoomPercentage(percentage: number) {
    this.zoomLevel = Math.min(Math.max(percentage / 100, 0.5), 2);
    this.applyZoomToContainer();
    this.showZoomIndicator = true;
    // Hide after 2 seconds automatically (optional)
    setTimeout(() => this.showZoomIndicator = false, 10000);
  }

  toggleZoomIndicator() {
    this.showZoomIndicator = !this.showZoomIndicator;
  }

  resetZoom() {
    console.log("zoom clicked")
    this.zoomLevel = 1; // reset zoom to 100%
    this.applyZoomToContainer();
    this.showZoomIndicator = true;
    setTimeout(() => this.showZoomIndicator = false, 100);
    this.cdr.detectChanges(); // ensure UI updates if needed
  }

  private applyZoomToContainer(): void {
    const el = this.zoomContainer?.nativeElement as HTMLElement | undefined;
    if (!el) return;

    // Prefer CSS `zoom` where supported so scaling works even when styles use `rem`/`px`.
    const supportsZoom = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('zoom', '1');
    if (supportsZoom) {
      el.style.setProperty('zoom', String(this.zoomLevel));
      // Clear any legacy font-size based zooming.
      el.style.removeProperty('font-size');
      el.style.removeProperty('line-height');
      return;
    }

    // Fallback: font-size based zoom (works when typography inherits from the container).
    const baseFontSize = 14;
    const newFontSize = baseFontSize * this.zoomLevel;
    el.style.removeProperty('zoom');
    el.style.fontSize = `${newFontSize}px`;
    el.style.lineHeight = `${newFontSize * 1.4}px`;
  }

  sendMessageWithAttachment(currentConv: any) {
    let promptId = '';
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      promptId = urlParams.get('templateId') || '';
    }

    const userMessageText = (this.upperText + ' ' + this.userInput).trim();
    this.userInput = '';
    this.upperText = '';
    this.transcriptBuffer = '';
    // The scratchpad just emptied into the outgoing message, so close it.
    // Its visibility is a separate flag from its content (unlike the overlay
    // chat window, which binds *ngIf straight to upperText), so clearing the
    // text alone would leave an empty panel sitting open.
    this.showScratchpad = false;
    let s3Url: string = '';
    if (typeof this.s3FileUrl === 'object' && this.s3FileUrl !== null) {
      s3Url = this.s3FileUrl.url || '';
    } else {
      s3Url = this.s3FileUrl as string;
    }
    const s3FileType = this.s3FileType;
    this.s3FileUrl = '';
    this.s3FileType = '';
    this.attachedFileName = '';
    if (this.fileInput) this.fileInput.nativeElement.value = '';
    if (currentConv.messages.length === 0) {
      this.chatService.updateConversationTitle(userMessageText.substring(0, 25) + '...');
    }

    let userMsgText = userMessageText;
    if (s3Url) {
      if (s3FileType === 'image') {
        // insert a small thumbnail wrapped in a link and force sizing with inline style
        userMsgText += `<br><a href='${s3Url}' target='_blank' rel='noopener noreferrer'><img class='chat-thumbnail' src='${s3Url}' alt='attachment' loading='lazy' decoding='async' draggable='false' style="width:150px;max-width:150px;max-height:320px;height:auto;object-fit:cover;border-radius:8px;display:inline-block;"/></a>`;
      } else {
        userMsgText += `<br><a href='${s3Url}' target='_blank' rel='noopener noreferrer'>View file</a>`;
      }
    }
    const userMsg: Message = { text: userMsgText, sender: 'user', timestamp: new Date() };
    this.chatService.addMessage(userMsg);

    const botPlaceholderMsg: Message = { text: '...', sender: 'bot', timestamp: new Date() };
    this.chatService.addMessage(botPlaceholderMsg);
    const botMessageIndex = currentConv.messages.length - 1;

    const chatId = promptId;
    this.chatStreamRelayWebSocketService.connect(chatId, () => { });

    let apiCall;
    if (s3FileType === 'image') {
      apiCall = this.openApiService.sendTextAndImageToOpenAI(userMessageText, s3Url);
    } else {
      apiCall = this.openApiService.sendTextAndFileToOpenAI(userMessageText, s3Url);
    }
    let fullAnswer = '';
    apiCall.subscribe({
      next: (response: any) => {
        const outputText = this.openApiService.extractOpenAIText(response);
        fullAnswer = outputText || 'No response';
        this.chatService.updateBotMessage(botMessageIndex, fullAnswer);
        // Send streamed chunk to backend relay
        this.chatStreamRelayWebSocketService.send(fullAnswer);
        // setTimeout(() => this.scrollToBottomWithPadding(20), 0);

      },
      error: (err) => {
        this.openApiService.saveAnswer(promptId, userMessageText, err, s3Url);
        this.chatService.updateBotMessage(botMessageIndex, 'Sorry, our Otter AI assistant couldn\'t process your attachment. Please try again or send your message without the file.');
        this.chatService.finalizeConversation();
        this.isStreaming = false; // Reset streaming state on error
        this.chatStreamRelayWebSocketService.close();
      },
      complete: () => {
        this.chatService.finalizeConversation();
        this.openApiService.saveAnswer(promptId, userMessageText, fullAnswer, s3Url);
        this.isStreaming = false; // Reset streaming state on complete
        this.chatStreamRelayWebSocketService.close();
      }
    });
  }

  async typeBotMessage(fullText: string, messageIndex: number) {
    const parts = fullText.split(/(```[\s\S]*?```)/);
    let currentText = '';

    for (const part of parts) {
      currentText += part;
      this.chatService.updateBotMessage(messageIndex, currentText);
      if (!part.startsWith('```')) {
        await new Promise(res => setTimeout(res, 20)); // Type regular text quickly
      } else {
        await new Promise(res => setTimeout(res, 50)); // Pause slightly for code blocks
      }
    }
    this.chatService.finalizeConversation();
    this.cdr.detectChanges();
    this.addCopyButtonsToCodeBlocks();
  }

  toggleMic() {
    // Toggle intent
    const turningOn = !this.isMicOn;
    if (turningOn) {
      // Try to start listening and only set isMicOn=true if successful
      this.transcriptBuffer = this.userInput;
      this.deepgramService.startListening((transcript: string, isFinal: boolean) => {
        if (isFinal) {
          this.transcriptBuffer += (this.transcriptBuffer ? ' ' : '') + transcript;
          this.userInput = this.transcriptBuffer;
        } else {
          this.userInput = this.transcriptBuffer + (this.transcriptBuffer ? ' ' : '') + transcript;
        }
        this.cdr.detectChanges();
        this.smoothScrollTextarea();
      }).then(() => {
        this.isMicOn = true;
        this.cdr.detectChanges();
      }).catch((err) => {
        console.error('Failed to start microphone:', err);
        this.isMicOn = false;
        this.cdr.detectChanges();
      });
    } else {
      // Turn off immediately in UI and stop backend listening
      this.isMicOn = false;
      this.stopRecording();
      this.deepgramService.stopListening();
      this.userInput = this.transcriptBuffer;
      this.cdr.detectChanges();
    }
  }

  stopRecording() {
    this.isMicOn = false;
    this.deepgramService.stopListening();
    this.userInput = this.transcriptBuffer;
  } 




  private smoothScrollTextarea(): void {
    if (this.textareaInput && this.textareaInput.nativeElement) {
      const textarea = this.textareaInput.nativeElement;
      // Use requestAnimationFrame for smooth scrolling
      requestAnimationFrame(() => {
        textarea.scrollTop = textarea.scrollHeight;
        // Apply smooth scroll behavior via CSS if supported
        textarea.style.scrollBehavior = 'smooth';
        // Reset to auto after scroll completes
        setTimeout(() => {
          if (textarea.style) {
            textarea.style.scrollBehavior = 'auto';
          }
        }, 300);
      });
    }
  }
  // Return SafeHtml so Angular does not strip Prism token spans from [innerHTML].
  // Results are memoized per message so that Angular change-detection does NOT
  // recreate the innerHTML on every cycle — which would destroy copy buttons and
  // break text selection while the bot is streaming.
  formatMessage(text: string, message?: Message): SafeHtml {
    // Build a stable cache key that encodes what actually matters for the output.
    // Include a slice of previousText so history messages with different baselines
    // but identical response text don't collide in the cache.
    const prevSlice = message?.previousText ? message.previousText.slice(0, 80) : '';
    const cacheKey = (message?.id ?? '') + '|' + text + '|' + (message?.showDiff ? '1' : '0') + '|' + prevSlice;

    if (this.formatCache.has(cacheKey)) {
      return this.formatCache.get(cacheKey)!;
    }

    let result: SafeHtml;

    // Check if we should show diff for this message
    if (message?.showDiff && message?.previousText) {
      result = this.formatMessageWithDiff(message.previousText, text);
    } else {
      const renderer = new Renderer();
      renderer.code = ({ text: code, lang }: { text: string; lang?: string }) => {
        const language = lang && Prism.languages[lang] ? lang : 'plaintext';

        // If the code block contains lines prefixed with -- or ++, render as inline diff.
        // Guard with messageHasCompleteCodeBlock: during streaming the full message text
        // may not yet have a closing ``` fence, so we wait until the block is complete
        // to avoid rendering partial/incorrect diff during live streaming.
        if (this.messageHasCompleteCodeBlock(text) && this.codeBlockHasDiffMarkers(code)) {
          const groupedHtml = this.buildInlineDiffHtml(code, language);
          return `<pre class="language-${language} diff-view"><code class="language-${language}">${groupedHtml}</code></pre>`;
        }

        let highlighted = code;
        try {
          if (language !== 'plaintext' && Prism.languages[language]) {
            highlighted = Prism.highlight(code, Prism.languages[language], language);
          } else {
            highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
        } catch (e) {
          highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
      };
      const preprocessed = this.wrapAsciiArt(text);
      const parsed = marked.parse(preprocessed, { renderer }) as string;
      result = this.sanitizer.bypassSecurityTrustHtml(parsed);
    }

    // Keep cache from growing unboundedly during long streaming sessions.
    // A limit of 200 entries is more than enough for any conversation.
    if (this.formatCache.size > 200) {
      const firstKey = this.formatCache.keys().next().value;
      if (firstKey !== undefined) this.formatCache.delete(firstKey);
    }
    this.formatCache.set(cacheKey, result);
    return result;
  }

  /**
   * Returns true when a raw code-block string contains at least one line
   * prefixed with "--" or "++" (the bot's inline diff marker convention).
   * We require at least one of each so we don't colour every shell script
   * that starts with a comment (# --).
   */
  private codeBlockHasDiffMarkers(code: string): boolean {
    const lines = code.split('\n');
    // A diff-marker line starts with optional whitespace then exactly "--" or "++"
    // followed by a non-marker char (so "---" or "+++" dividers are excluded).
    const hasDel = lines.some(l => /^[ \t]*--(?!-)/.test(l));
    const hasAdd = lines.some(l => /^[ \t]*\+\+(?!\+)/.test(l));
    // Require BOTH markers. Also, at least one -- and one ++ must both be present,
    // meaning the response is complete enough to render. This prevents partial
    // streaming chunks (which only have -- but not ++ yet) from triggering diff mode.
    return hasDel && hasAdd;
  }

  /**
   * Returns true only when the full message text contains at least one complete
   * fenced code block (opening AND closing backtick fence). Used to guard against
   * applying inline-diff rendering to still-streaming partial text.
   */
  private messageHasCompleteCodeBlock(text: string): boolean {
    // A complete fenced block has opening ``` ... closing ```
    const fenceRegex = /```[\s\S]*?```/;
    return fenceRegex.test(text);
  }

  /**
   * Detects ASCII art / diagrams outside of code fences and wraps them in
   * ``` fences so `marked` renders them as <pre> blocks instead of mangling
   * them into tables, lists, or paragraphs.
   *
   * Streaming-safe: if the text contains an unclosed code fence (still being
   * streamed), only the portion before that fence is processed.
   */
  private wrapAsciiArt(text: string): string {
    // During streaming the text may end with an unclosed code fence.
    // Detect this so we don't accidentally inject fences inside it.
    const fenceMarkers = text.match(/```/g);
    const hasUnclosedFence = fenceMarkers && fenceMarkers.length % 2 !== 0;

    let processable = text;
    let tail = '';
    if (hasUnclosedFence) {
      // Everything from the last (unclosed) ``` onwards is left untouched.
      const lastFenceIdx = text.lastIndexOf('```');
      processable = text.substring(0, lastFenceIdx);
      tail = text.substring(lastFenceIdx);
    }

    const processed = this.wrapAsciiArtInText(processable);
    return processed + tail;
  }

  /** Core ASCII-art wrapping logic, operates only on text with balanced fences. */
  private wrapAsciiArtInText(text: string): string {
    // Unicode box-drawing characters
    const boxDrawing = /[┌┐└┘├┤┬┴┼─│═║╔╗╚╝╠╣╦╩╬╟╢╤╧╪┃┄┅┆┇┈┉┊┋╭╮╯╰]/;
    // ASCII box corner/edge pattern: +---+ or |---| etc.
    const asciiBoxLine = /^[ \t]*[+|][-=+]{2,}/;
    // Lines with 2+ pipe characters forming box borders
    const multiPipe = (line: string) => (line.match(/\|/g) || []).length >= 2;
    // Lines that are purely structural: only whitespace, +, -, |, =, /
    const structuralLine = /^[ \t]*[+\-|=\/\\]+[ \t]*$/;
    // Arrow patterns common in diagrams
    const arrowPattern = /[-=]{2,}>|<[-=]{2,}|──>|<──|═══|╌╌>|→|←|↑|↓|↗|↘|↙|↖/;
    // 3D-style box lines using / and \ with pipes
    const box3dLine = /[\/\\].*\||\|.*[\/\\]/;

    const isAsciiArtLine = (line: string): boolean => {
      const trimmed = line.trim();
      if (trimmed.length < 2) return false;
      // Unicode box-drawing chars are a strong signal
      if (boxDrawing.test(line)) return true;
      // ASCII +---+ or |---+ style borders
      if (asciiBoxLine.test(line)) return true;
      // Purely structural line: +--+--+ or |---|
      if (structuralLine.test(line) && trimmed.length >= 3) return true;
      // Line with 2+ pipes AND either a box corner, structural chars, or 3D chars
      if (multiPipe(line) && (/[+]/.test(line) || box3dLine.test(line) || /[-=]{2,}/.test(line))) return true;
      // Arrow diagram lines that also contain box characters
      if (arrowPattern.test(line) && (line.includes('|') || /[+]/.test(line) || boxDrawing.test(line))) return true;
      // 3D perspective lines with / or \ combined with pipes
      if (box3dLine.test(line) && /[-=+]/.test(line)) return true;
      return false;
    };

    // Split text into segments: inside complete code fences vs outside
    const parts = text.split(/(```[\s\S]*?```)/g);
    const result: string[] = [];

    for (const part of parts) {
      // Complete code fence — keep as-is
      if (part.startsWith('```')) {
        result.push(part);
        continue;
      }

      // Process non-fenced text: find consecutive ASCII art lines and wrap them
      const lines = part.split('\n');
      let i = 0;
      const output: string[] = [];

      while (i < lines.length) {
        if (isAsciiArtLine(lines[i])) {
          // Collect the full diagram block: art lines, blank lines between them,
          // and label/text lines sandwiched between art lines (up to 2 lookahead).
          const blockStart = i;
          i++;
          while (i < lines.length) {
            if (isAsciiArtLine(lines[i])) {
              i++;
            } else if (i + 1 < lines.length && isAsciiArtLine(lines[i + 1])) {
              // Non-art line (label or blank) followed by art — include both
              i++;
            } else if (i + 2 < lines.length && isAsciiArtLine(lines[i + 2])) {
              // Two non-art lines followed by art (e.g. blank + label) — include
              i++;
            } else {
              break;
            }
          }
          const blockLines = lines.slice(blockStart, i);
          // Require at least 2 art lines to avoid false positives
          if (blockLines.filter(l => isAsciiArtLine(l)).length >= 2) {
            output.push('```');
            output.push(...blockLines);
            output.push('```');
          } else {
            output.push(...blockLines);
          }
        } else {
          output.push(lines[i]);
          i++;
        }
      }

      result.push(output.join('\n'));
    }

    return result.join('');
  }

  /**
   * Build diff HTML directly from a code block that uses --/++ line prefixes.
   * Lines starting with "--" become .ln-del (red), "++" become .ln-add (green),
   * all others are .ln-unchanged. Groups removed before added within each hunk.
   */
  private buildInlineDiffHtml(code: string, language: string): string {
    const lines = code.split('\n');
    const htmlParts: string[] = [];
    let hunkRemoved: string[] = [];
    let hunkAdded: string[] = [];

    const flushHunk = () => {
      for (const line of hunkRemoved) {
        htmlParts.push(`<div class="ln-del">${line}</div>`);
      }
      for (const line of hunkAdded) {
        htmlParts.push(`<div class="ln-add">${line}</div>`);
      }
      hunkRemoved = [];
      hunkAdded = [];
    };

    for (const rawLine of lines) {
      // Detect leading -- or ++ (allow optional indentation before the marker)
      const delMatch = rawLine.match(/^(\s*)--(.*)/);
      const addMatch = rawLine.match(/^(\s*)\+\+(.*)/);

      if (delMatch) {
        // Strip the "--" prefix, keep indentation + rest of line
        const cleanLine = delMatch[1] + delMatch[2];
        hunkRemoved.push(this.highlightDiffLine(cleanLine, language));
      } else if (addMatch) {
        const cleanLine = addMatch[1] + addMatch[2];
        hunkAdded.push(this.highlightDiffLine(cleanLine, language));
      } else {
        flushHunk();
        htmlParts.push(`<div class="ln-unchanged">${this.highlightDiffLine(rawLine, language)}</div>`);
      }
    }
    flushHunk();
    return htmlParts.join('');
  }

  /**
   * Format message with diff highlighting (++ for additions, -- for deletions).
   * Diff is applied ONLY to the first code block in the response.
   * All subsequent code blocks (e.g. "Complete code") render normally with Prism.
   * Inline bot marker comments (// DELETE THIS LINE, // ADD THIS LINE, etc.) are
   * stripped from the new code before diff generation so they don't pollute the output.
   * Removed lines (--) are grouped before added lines (++) for clarity.
   */
  formatMessageWithDiff(oldText: string, newText: string): SafeHtml {
    // Fix 3: Don't diff while streaming — wait until new response has a complete code block.
    // If the closing ``` fence hasn't arrived yet, fall back to normal rendering.
    // Once the block is complete the cache key changes and this re-renders as a proper diff.
    if (!this.messageHasCompleteCodeBlock(newText)) {
      const renderer = new Renderer();
      renderer.code = ({ text: code, lang }: { text: string; lang?: string }) => {
        const language = lang && Prism.languages[lang] ? lang : 'plaintext';
        let highlighted = code;
        try {
          if (language !== 'plaintext' && Prism.languages[language]) {
            highlighted = Prism.highlight(code, Prism.languages[language], language);
          } else {
            highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
        } catch (e) {
          highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
      };
      const parsed = marked.parse(newText, { renderer }) as string;
      return this.sanitizer.bypassSecurityTrustHtml(parsed);
    }

    const renderer = new Renderer();

    // Extract the first code block from the OLD response to diff against.
    // Also sanitize it: strip any diff markers (-- / ++) the bot may have embedded
    // in a previous diff-view response, so they don't corrupt the baseline.
    const oldCodeMatch = oldText.match(/```[\w]*\n?([\s\S]*?)```/);
    const rawOldCode = oldCodeMatch ? oldCodeMatch[1].trim() : '';
    const oldCode = this.sanitizeCodeForDiff(rawOldCode);

    // Counter to track which code block we are rendering (0-based)
    let codeBlockIndex = 0;

    renderer.code = ({ text: code, lang }: { text: string; lang?: string }) => {
      const language = lang && Prism.languages[lang] ? lang : 'plaintext';
      const currentIndex = codeBlockIndex++;

      // Only the first code block gets diff treatment
      if (currentIndex === 0 && oldCode) {
        // Strip commented-out code lines (// ...) from new code before diffing.
        // The bot sometimes includes the old version commented out inside the new response,
        // which causes all those lines to appear as green "added" lines in the diff.
        const cleanedNewCode = this.sanitizeCodeForDiff(
          code.split('\n').filter(l => !/^\s*\/\//.test(l)).join('\n')
        );

        // Fix 1: Similarity gate — if old and new code share < 20% common lines,
        // they are completely unrelated (e.g. bubble sort vs linked list).
        // Also skip when oldCode is empty (previous response had no extractable code block).
        const oldLines = oldCode.split('\n').filter(l => l.trim().length > 2);
        const newLines = cleanedNewCode.split('\n').filter(l => l.trim().length > 2);
        const skipDiff = oldLines.length === 0 || newLines.length === 0 ||
          (oldLines.filter(l => newLines.includes(l)).length / Math.max(oldLines.length, newLines.length)) < 0.2;

        if (skipDiff) {
          // Too different or no extractable baseline — render as normal Prism block
          const safeCode = this.sanitizeCodeForDiff(code);
          let highlighted = safeCode;
          try {
            if (language !== 'plaintext' && Prism.languages[language]) {
              highlighted = Prism.highlight(safeCode, Prism.languages[language], language);
            } else {
              highlighted = safeCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }
          } catch (e) {
            highlighted = safeCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
          return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
        }

        const diffLines = this.diffService.generateDiff(oldCode, cleanedNewCode);

        // Group: collect removed lines first, then added lines, then unchanged
        // within each contiguous hunk so -- appears before ++ for the same change region
        const groupedHtml = this.buildGroupedDiffHtml(diffLines, language);

        return `<pre class="language-${language} diff-view"><code class="language-${language}">${groupedHtml}</code></pre>`;
      }

      // Subsequent code blocks: render normally with Prism (no diff).
      // Still sanitize to strip bot's ++/-- prefixes and marker comments from the clean code.
      const cleanCode = this.sanitizeCodeForDiff(code);
      let highlighted = cleanCode;
      try {
        if (language !== 'plaintext' && Prism.languages[language]) {
          highlighted = Prism.highlight(cleanCode, Prism.languages[language], language);
        } else {
          highlighted = cleanCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
      } catch (e) {
        highlighted = cleanCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
    };

    const parsed = marked.parse(newText, { renderer }) as string;
    return this.sanitizer.bypassSecurityTrustHtml(parsed);
  }

  /**
   * Build diff HTML from DiffLine[], grouping removed lines before added lines
   * within each contiguous change hunk (-- lines first, then ++ lines).
   * Unchanged lines are emitted as-is in their natural position.
   */
  private buildGroupedDiffHtml(diffLines: Array<{ type: 'add' | 'remove' | 'unchanged'; content: string }>, language: string): string {
    const htmlParts: string[] = [];
    let hunkRemoved: string[] = [];
    let hunkAdded: string[] = [];

    const flushHunk = () => {
      // Emit all removed lines first (−), then all added lines (+)
      for (const line of hunkRemoved) {
        htmlParts.push(`<div class="ln-del">${line}</div>`);
      }
      for (const line of hunkAdded) {
        htmlParts.push(`<div class="ln-add">${line}</div>`);
      }
      hunkRemoved = [];
      hunkAdded = [];
    };

    for (const diffLine of diffLines) {
      const highlighted = this.highlightDiffLine(diffLine.content, language);

      if (diffLine.type === 'remove') {
        hunkRemoved.push(highlighted);
      } else if (diffLine.type === 'add') {
        hunkAdded.push(highlighted);
      } else {
        // Unchanged line — flush any pending hunk first
        flushHunk();
        htmlParts.push(`<div class="ln-unchanged">${highlighted}</div>`);
      }
    }

    // Flush any remaining hunk at end of file
    flushHunk();

    return htmlParts.join('');
  }

  private highlightDiffLine(content: string, language: string): string {
    try {
      if (language !== 'plaintext' && Prism.languages[language]) {
        return Prism.highlight(content, Prism.languages[language], language);
      }
    } catch (_) { /* fall through */ }
    return content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /**
   * Strip noise from a code string before feeding it to generateDiff():
   *  1. Bot inline marker comments: // DELETE THIS LINE, // ADD THIS LINE, etc.
   *  2. Diff prefix markers the bot wrote at line start: "-- " or "++ " prefixes
   *     (e.g. "--System.out.println(rev(...));" or "++reverseStr(...")
   *  3. Empty lines that result from the stripping
   * Returns cleaned code ready for LCS diffing.
   */
  private sanitizeCodeForDiff(code: string): string {
    // Marker words that indicate a bot-added diff annotation comment
    const markerWords = /\b(add|added|remove|removed|delete|deleted|change|changed|modify|modified|insert|inserted|old|new|keep|replace|this line|new line|old line)\b/i;

    let cleaned = code
      .split('\n')
      .map(line => {
        // Step 1: Strip leading "++ " or "-- " diff-marker prefixes the bot writes.
        // e.g. "++    code;" → "    code;"   |   "--code" → "code"
        line = line.replace(/^(\s*)(\+\+|--)\s?/, '$1');

        // Step 2: Find the first // or # comment on the line and strip it if it
        // contains a marker word. We search left-to-right for comment starts so
        // that semicolons inside the code part don't block us.
        // Works for: "code; // ADD THIS LINE", "code;// delete", "code # new"
        const commentIdx = this.findCommentStart(line);
        if (commentIdx !== -1) {
          const commentText = line.slice(commentIdx);
          if (markerWords.test(commentText)) {
            // Strip the comment (and any trailing whitespace before it)
            line = line.slice(0, commentIdx).trimEnd();
          }
        }

        return line;
      })
      .join('\n');

    // Step 3: Collapse runs of 3+ blank lines to at most one, and trim overall
    cleaned = cleaned.replace(/\n{3,}/g, '\n\n').trim();

    return cleaned;
  }

  /**
   * Find the index of the first // or # comment start in a line of code.
   * Skips over string literals so we don't match "//" inside a quoted string.
   * Returns -1 if no comment found.
   */
  private findCommentStart(line: string): number {
    let inSingle = false;
    let inDouble = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      const prev = i > 0 ? line[i - 1] : '';
      if (ch === "'" && !inDouble && prev !== '\\') { inSingle = !inSingle; continue; }
      if (ch === '"' && !inSingle && prev !== '\\') { inDouble = !inDouble; continue; }
      if (inSingle || inDouble) continue;
      // Outside strings: check for comment markers
      if (ch === '/' && line[i + 1] === '/') return i;
      if (ch === '#') return i;
    }
    return -1;
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Returns true whenever the previous bot response contained a code block.
   * The diff renderer itself handles the visual output — if the new response
   * also has code, red/green lines are shown; if not, it falls back to normal
   * rendering inside formatMessageWithDiff.
   * The only hard exclusions are non-coding conversational replies
   * (e.g. "thanks", "ok", "who are you") that clearly have no code intent.
   */
  private shouldShowDiffForUserMessage(userMessage: string): boolean {
    if (!this.enableDiffView || !this.lastBotResponse) {
      return false;
    }

    // Only show diff when the previous response actually contained code
    if (!this.lastBotResponse.includes('```')) {
      return false;
    }

    const lowerMsg = userMessage.toLowerCase().trim();
    const words = lowerMsg.split(/\s+/);
    const wordCount = words.length;

    // Exclude very short purely conversational messages (1-2 words, no code intent)
    if (wordCount <= 2) {
      const nonCodingWords = /^(ok|okay|thanks|thank|yes|no|sure|great|nice|good|got it|cool|fine|done|hi|hello|hey|bye|lol|hmm|yep|nope|alright|sounds good)$/i;
      if (nonCodingWords.test(lowerMsg)) {
        return false;
      }
    }

    // Always show diff when previous response had code — let the diff renderer decide
    console.log('Diff triggered: previous response contained code');
    return true;
  }

  /**
   * Check if two responses are similar enough to show diff
   * Uses code similarity and content overlap
   */
  private isSimilarResponse(oldResponse: string, newResponse: string): boolean {
    // Must both contain code blocks
    const oldHasCode = oldResponse.includes('```');
    const newHasCode = newResponse.includes('```');
    
    if (!oldHasCode || !newHasCode) {
      return false; // Only show diff for code changes
    }

    // Extract code blocks
    const oldCode = this.extractCodeBlocks(oldResponse).join('\n');
    const newCode = this.extractCodeBlocks(newResponse).join('\n');

    if (!oldCode || !newCode) {
      return false;
    }

    // Calculate similarity using common lines
    const oldLines = oldCode.split('\n').filter(l => l.trim().length > 2);
    const newLines = newCode.split('\n').filter(l => l.trim().length > 2);
    
    if (oldLines.length === 0 || newLines.length === 0) {
      return false;
    }

    // Count common lines
    const commonLines = oldLines.filter(line => newLines.includes(line)).length;
    const similarity = commonLines / Math.max(oldLines.length, newLines.length);

    // If > 40% similar, show diff
    return similarity > 0.4;
  }

  /**
   * Extract all code blocks from markdown text
   */
  private extractCodeBlocks(text: string): string[] {
    const codeBlockRegex = /```[\w]*\n?([\s\S]*?)```/g;
    const matches: string[] = [];
    let match;
    
    while ((match = codeBlockRegex.exec(text)) !== null) {
      if (match[1]) {
        matches.push(match[1].trim());
      }
    }
    
    return matches;
  }


  /**
   * Toggle diff view mode (optional - currently always enabled)
   */
  toggleDiffView(): void {
    this.enableDiffView = !this.enableDiffView;
    this.toastService.show(
      `Diff view ${this.enableDiffView ? 'enabled' : 'disabled'}`,
      'info'
    );
  }

  /**
   * Save last bot response to localStorage (persists across refresh)
   */
  private saveLastBotResponse(promptId: string, response: string): void {
    if (typeof window !== 'undefined' && promptId) {
      const key = `lastBotResponse_${promptId}`;
      try {
        localStorage.setItem(key, response);
      } catch (e) {
        console.warn('Failed to save last bot response to localStorage', e);
      }
    }
  }

  /**
   * Load last bot response from localStorage
   */
  private loadLastBotResponse(promptId: string): void {
    if (typeof window !== 'undefined' && promptId) {
      const key = `lastBotResponse_${promptId}`;
      try {
        const saved = localStorage.getItem(key);
        if (saved) {
          this.lastBotResponse = saved;
          console.log('Loaded last bot response from localStorage for diff comparison');
        }
      } catch (e) {
        console.warn('Failed to load last bot response from localStorage', e);
      }
    }
  }

  copyCodeBlock(index: number) {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv || !currentConv.messages[index]) return;
      const msg = currentConv.messages[index];
      // Extract code block from message text
      const codeMatch = msg.text.match(/```([\s\S]*?)```/);
      if (codeMatch && codeMatch[1]) {
        const code = codeMatch[1].trim();
        this.copyTextToClipboard(code);
      }
    });
  }

  addCopyButtonsToCodeBlocks() {
    if (!this.scrollContainer?.nativeElement) return;

    // Run Prism only on NON-diff pre blocks (diff blocks already have custom HTML)
    try {
      const nonDiffPres = this.scrollContainer.nativeElement.querySelectorAll('pre:not(.diff-view)');
      nonDiffPres.forEach((pre: HTMLElement) => {
        try { Prism.highlightAllUnder(pre); } catch (e) {}
      });
    } catch (e) {}

    const preElements = this.scrollContainer.nativeElement.querySelectorAll('pre');
    preElements.forEach((pre: HTMLElement) => {
      // Skip if button already added
      if (pre.querySelector('.copy-btn')) return;
      pre.style.position = 'relative';

      const button = this.renderer.createElement('button');
      this.renderer.addClass(button, 'copy-btn');
      this.renderer.setAttribute(button, 'type', 'button');
      this.renderer.setAttribute(button, 'aria-label', 'Copy code');
      button.innerHTML = '<span class="material-icons">content_copy</span>';

      const onClick = (ev: Event) => {
        ev.stopPropagation();
        // For diff view: read each line div's innerText separately to avoid CSS ::before content
        let code: string;
        if (pre.classList.contains('diff-view')) {
          // Copy only the final code: added lines (++) and unchanged lines.
          // Deleted lines (--) are skipped — they represent the old code being removed.
          const lineDivs = pre.querySelectorAll('.ln-add, .ln-unchanged');
          code = Array.from(lineDivs).map((d: Element) => (d as HTMLElement).innerText).join('\n');
        } else {
          code = pre.querySelector('code')?.innerText || pre.innerText || '';
        }
        this.copyTextToClipboard(
          code,
          () => {
            button.innerHTML = '<span class="material-icons">check_circle</span>';
            this.renderer.addClass(button, 'copied');
            setTimeout(() => {
              button.innerHTML = '<span class="material-icons">content_copy</span>';
              this.renderer.removeClass(button, 'copied');
            }, 1500);
          },
          () => { this.renderer.removeClass(button, 'copied'); }
        );
      };

      this.renderer.listen(button, 'click', (ev: Event) => { onClick(ev as Event); });
      this.renderer.appendChild(pre, button);
    });
  }

  // scrollToBottom(): void {
  //   try {
  //     // Only scroll to the bottom if the user is not currently scrolling
  //     if (!this.isUserScrolling) {
  //       this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  //     }
  //   } catch (err) {
  //     console.error('Error while scrolling:', err);
  //   }
  // }


  // This method should be called when user stops scrolling (e.g., by using a timeout or debounce)


  summarizeConversation() {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv || currentConv.messages.length < 2 || this.isSummarizing) return;
      this.isSummarizing = true;
      this.openApiService.getSummary(currentConv.messages).subscribe({
        next: (response: SummaryResponse) => {
          if (response && response.title && response.summary) {
            const htmlContent = `<h1>${response.title}</h1>${marked.parse(response.summary) as string}`;
            const cleanFileName = response.title.toLowerCase().replace(/[\s\W-]+/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '');
            this.downloadContentAsDoc(htmlContent, `${cleanFileName || 'chat_summary'}.doc`);
          }
          this.isSummarizing = false;
        },
        error: () => {
          this.toastService.show('Failed to generate summary. Please try again.', 'error');
          this.isSummarizing = false;
        }
      });
    });
  }

  downloadDoc(msg: Message) {
    if (!msg || !msg.text) return;
    const htmlContent = marked.parse(msg.text) as string;
    this.downloadContentAsDoc(htmlContent, 'AIResponse.doc');
  }

  private downloadContentAsDoc(htmlContent: string, fileName: string) {
    const header = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export</title></head><body>`;
    const footer = "</body></html>";
    const sourceHTML = header + htmlContent + footer;
    const blob = new Blob(['\ufeff', sourceHTML], { type: 'application/msword' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  onInputKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      // Block Enter while streaming — only the stop button should abort the stream.
      // This prevents accidental double-Enter from stopping an in-progress response.
      if (this.isStreaming) return;
      this.sendMessage();
    }
    // If Shift+Enter, let it add a new line (default behavior)
  }





  async onFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      await this.processFile(input.files[0]);
    }
  }

  onPaste(event: ClipboardEvent): void {
    const items = event.clipboardData?.items;
    if (!items) return;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.startsWith('image/')) {
        event.preventDefault();
        const file = items[i].getAsFile();
        if (file) this.processFile(file);
        return;
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.processFile(files[0]);
    }
  }

  private async processFile(file: File): Promise<void> {
    const isImage = file.type.startsWith('image/');
    const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
    if (!isImage && !isPdf) {
      this.fileTypeError = 'Only image and PDF files are supported.';
      return;
    }
    this.fileTypeError = '';
    this.isUploadingAttachment = true;
    if (isImage) {
      const base64 = await this.convertToBase64(file);
      this.openApiService.uploadBase64File({ base64Content: base64 }).subscribe({
        next: (url: string) => {
          this.s3FileUrl = url;
          this.s3FileType = 'image';
          this.attachedFileName = file.name || 'pasted-image.png';
          this.isUploadingAttachment = false;
        },
        error: (err) => {
          this.s3FileUrl = '';
          this.s3FileType = '';
          this.attachedFileName = '';
          this.isUploadingAttachment = false;
          if (this.fileInput) this.fileInput.nativeElement.value = '';
          this.toastService.show('Image upload failed. Please try again.', 'error');
        }
      });
    } else if (isPdf) {
      const textContent = await this.readFileAsText(file);
      this.openApiService.uploadTextFile({ textContent, fileName: file.name }).subscribe({
        next: (url: string) => {
          this.s3FileUrl = url;
          this.s3FileType = 'file';
          this.attachedFileName = file.name;
          this.isUploadingAttachment = false;
        },
        error: (err) => {
          this.s3FileUrl = '';
          this.s3FileType = '';
          this.attachedFileName = '';
          this.isUploadingAttachment = false;
          if (this.fileInput) this.fileInput.nativeElement.value = '';
          this.toastService.show('File upload failed. Please try again.', 'error');
        }
      });
    }
  }

  async convertToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1] || result;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async readFileAsText(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsText(file);
    });
  }


  // copyToClipboard(text: string): void {
  //   navigator.clipboard.writeText(text).then(() => {
  //     this.copiedMessage = text;
  //     setTimeout(() => this.copiedMessage = null, 1500);
  //   });
  // } 

  copyToClipboard(msg: Message): void {
    this.copyTextToClipboard(this.plainTextOf(msg), () => {
      msg.copied = true;
      setTimeout(() => {
        msg.copied = false;
      }, 2000);
    }, (err) => {
      // Optionally show error feedback, e.g. toast
      msg.copied = false;
      // You can use a toast service here if available
      // this.toastService.showError('Copy failed: ' + err);
    });
  }

  copyTextToClipboard(text: string, onSuccess?: () => void, onError?: (err: any) => void) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => onSuccess && onSuccess())
        .catch(err => {
          // fallback if clipboard API fails
          this.fallbackCopyTextToClipboard(text, onSuccess, onError);
        });
    } else {
      this.fallbackCopyTextToClipboard(text, onSuccess, onError);
    }
  }

  fallbackCopyTextToClipboard(text: string, onSuccess?: () => void, onError?: (err: any) => void) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);
      if (successful) {
        onSuccess && onSuccess();
      } else {
        onError && onError('execCommand failed');
      }
    } catch (err) {
      onError && onError(err);
    }
  }
  

  scrollToBottom(force: boolean = false): void {
    try {
      if (!this.isUserScrolling || force) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
        this.isNearBottom = true;
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }


  // This method is triggered when the user starts scrolling
  onUserScroll(): void {
    const scrollTop = this.scrollContainer.nativeElement.scrollTop;
    const scrollHeight = this.scrollContainer.nativeElement.scrollHeight;
    const clientHeight = this.scrollContainer.nativeElement.clientHeight;

    // User is scrolling manually, we set the flag to true
    this.isUserScrolling = true;

    // Check if the user is near the bottom (e.g., within 50px of the bottom)
    this.isNearBottom = (scrollHeight - scrollTop - clientHeight) < 50;
  }

  // This method is triggered when the user stops scrolling
  onUserStopScroll(): void {
    setTimeout(() => {
      if (!this.isStreaming && this.isNearBottom) {
        this.isUserScrolling = false;
        this.scrollToBottom(true);
      }
    }, 1000); // shorter, more responsive
  }



fetchAiApiKeys(): void { 
  this.openApiService.getApiKeys().subscribe({
    next: async (keys: { openAiKey: string; claudeAiKey: string }) => {
      try {
        const aesKeyBase64 = AES_SECRET_KEY;
        const { cryptoKey, fallbackKeyBytes } = await importAesKey(aesKeyBase64);
        try {
          console.debug('AES import result', {
            aesKeyBase64Length: aesKeyBase64?.length || 0,
            cryptoKeyIsNull: cryptoKey === null,
            fallbackKeyBytesLen: fallbackKeyBytes ? fallbackKeyBytes.length : 0
          });
        } catch (dbgErr) {
          console.debug('AES import debug failed', dbgErr);
        }
        this.openAiKey = await decryptKey(keys.openAiKey, cryptoKey, fallbackKeyBytes);
        this.claudeAiKey = await decryptKey(keys.claudeAiKey, cryptoKey, fallbackKeyBytes);
        this.openApiService.setKeys(this.openAiKey, this.claudeAiKey);
      } catch (e) {
        console.error('Error decrypting keys', e);
        this.toastService.show('Failed to initialize Otter AI assistant. Please refresh the page.', 'error');
      }
    },
    error: (err) => {
      console.error('Failed to load API keys', err);
      this.toastService.show('Failed to connect to Otter AI assistant. Please refresh the page.', 'error');
    }
  });
}
}
